import { Typography } from "@mui/material";
import { getDay, getFullTime } from "../../../helper/function";


const FieldReportDetails = (props) => {
  console.log("fr Details", props);
  const item = props?.dataDetails
  return (
    <div
      className="modal fade"
      id="frDetail_modal"
      tabIndex={-1}
      aria-labelledby="frDetail_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h2
                style={{
                  fontWeight: "bold",
                  padding: "0em",
                  margin: "0em",
                }}
                clasName="mb-0 ml-2"
              >
                Field Report Detail — ⏲️ {getDay(item?.createdAt)} {getFullTime(item?.createdAt)}
              </h2>
            </div>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <Typography variant="h6">Laporan:</Typography>
            <Typography paragraph>{item?.laporan}</Typography>
            <Typography variant="h6">Gambar Lapangan:</Typography>
            <div style={{ width: "auto", height: "auto" }}>
              {item?.imagesPath.length == 0 && (<>Tidak ada gambar.</>)}
              {item?.imagesPath.map((image, i) => (
                <>
                  {/* {"Debug img url : " + image}
                  <br /> */}
                  <img key={i} src={image} width="100%" alt="details-image" />
                </>
              ))}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default FieldReportDetails